module.exports = __webpack_public_path__ + "static/media/redo.029554f9.svg";